import { render, staticRenderFns } from "./BaseControlBar.vue?vue&type=template&id=b552e662&scoped=true&"
import script from "./BaseControlBar.vue?vue&type=script&lang=js&"
export * from "./BaseControlBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseControlBar.vue?vue&type=style&index=0&id=b552e662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b552e662",
  null
  
)

export default component.exports